import { render, staticRenderFns } from "./ActBaseRankingList.vue?vue&type=template&id=6f05c616&scoped=true&"
import script from "./ActBaseRankingList.vue?vue&type=script&lang=js&"
export * from "./ActBaseRankingList.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseRankingList.vue?vue&type=style&index=0&id=6f05c616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05c616",
  null
  
)

export default component.exports